// @flow

import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { dynamicClassName } from 'utils/dynamicClassName';
import { getCompetitionTag } from 'utils/graphResponseUtils';
import { formatDateWithAbbvStr, getHourAndMinutesStr, getDateFromString } from 'utils/dateUtils';
import { usePlaceholderOnImageError } from 'utils/assetsUtils';
import { ffrName } from 'utils/ffrNameUtils';
import type { RencontreLiveType, RencontreArticleType } from 'types/Rencontre';
type Props = {
  match: RencontreArticleType,
  link?: string,
  isBig?: boolean,
  upcomingMatch?: boolean,
  isOver?: boolean,
  isDark?: boolean,
  lives?: {
    [key: string]: RencontreLiveType
  }
};

export default class CompetitionCard extends PureComponent<Props> {
  static defaultProps = {
    isBig: false,
    upcomingMatch: false,
    isDark: false,
    isOver: false
  };

  render() {
    const {
      match: { id, competition, localStructure, visiteurStructure, etat, journee, dateEffective, forfait },
      link,
      isBig,
      upcomingMatch,
      isDark,
      isOver,
      lives
    } = this.props;

    const nom = competition && competition.nom ? competition.nom : '';

    // Gestion du css
    const cardWrapperClasses = dynamicClassName('box card card--score');
    isBig && cardWrapperClasses.add('is--big');
    isDark && cardWrapperClasses.add('is--dark');
    upcomingMatch && cardWrapperClasses.add('upcoming');
    isOver && cardWrapperClasses.add('over');

    // Gestion état du match
    let label = etat === 'Planifiée' ? 'À venir' : forfait ? 'Forfait' : 'Terminée';
    if (etat === 'Péréquation' || etat === 'Annulée' || etat === 'En instance') {
      label = etat;
    }
    if (lives && Object.keys(lives).length > 0) {
      const rencontresLiveIds = Object.keys(lives);

      if (rencontresLiveIds.indexOf(id) >= 0) {
        label = 'En direct';
      }
    }

    // render
    return (
      <Link className={cardWrapperClasses.build()} to={link ? link : '/'}>
        <div className="card__header">
          <div>
            <span className="ft-up ft-700">{getCompetitionTag(competition)}</span>
            <span className="ft-500">{`${nom} — ${journee}`}</span>
          </div>
          <span className="ft-h6 ft-up label">{label}</span>
        </div>
        <div className="card__body">
          <div className="match">
            <div className="match__club">
              <p className="ft-h3 ft-400">
                <span>{ffrName(localStructure.nom)}</span>
                <img
                  src={localStructure.embleme}
                  alt={`Logo ${localStructure.nom}`}
                  style={{ width: '24', height: '24' }}
                  onError={e => usePlaceholderOnImageError(e.target, '/img/logo/placeholder-club.png')}
                />
              </p>
            </div>
            <div className="match__info">
              <p className="match__time ft-700 ft-up">
                {formatDateWithAbbvStr(getDateFromString(dateEffective))}
                <br />
                {getHourAndMinutesStr(getDateFromString(dateEffective))}
              </p>
            </div>
            <div className="match__club">
              <p className="ft-h3 ft-400">
                <span>{ffrName(visiteurStructure.nom)}</span>
                <img
                  src={visiteurStructure.embleme}
                  alt={`Logo ${visiteurStructure.nom}`}
                  style={{ width: '24', height: '24' }}
                  onError={e => usePlaceholderOnImageError(e.target, '/img/logo/placeholder-club.png')}
                />
              </p>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}
